import type { SVGProps } from "react";
// generated from Convert.svg — do not edit manually
// prettier-ignore
export default function Convert(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 2 14 C 2 14 2.121 14.849 5.636 18.364 C 9.151 21.879 14.849 21.879 18.364 18.364 C 19.609 17.119 20.413 15.599 20.776 14 M 2 14 V 20 M 2 14 H 8 M 22 10 C 22 10 21.879 9.151 18.364 5.636 C 14.849 2.121 9.151 2.121 5.636 5.636 C 4.391 6.881 3.587 8.401 3.224 10 M 22 10 V 4 M 22 10 H 16" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
